<template>
  <div>
    <v-card
      outlined
      :height="height"
      class="d-block align-center justify-center text-truncate"
    >
      <v-list-item class="px-2 py-0 my-0">
        <!-- <v-avatar
                            rounded
                            :color="
                              $vuetify.theme.dark
                                ? 'grey darken-3'
                                : 'grey lighten-3'
                            "
                            class="mr-2"
                          >
                            <v-img contain :src="member.photoUrl"></v-img>
                          </v-avatar> -->
        <v-list-item-content class="py-2">
          <v-list-item-title class="subtitle-2 font-weight-medium">{{
            user.user.displayName
          }}</v-list-item-title>
          <v-list-item-subtitle>
            {{ user.user.rank.shortTitle }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider v-if="showDivider" class="my-0"></v-divider>
      <v-card-text class="py-0 px-2">
        <slot name="belowSubtitle"></slot>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "matrix-person-card",
  components: {},
  props: {
    user: {
      type: Object,
      required: true,
    },
    height: {
      type: String,
      default: "42px",
      required: false,
    },
    showDivider: {
      type: Boolean,
      default: false,
    },
  },
  methods: {},
};
</script>
